import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import MANoList from "./MANoList";
import ProfileImageWithFallback from "../../../../common/ProfileImageWithFallback";
import ConfirmModal from "../../../Common/ConfirmModal";

export default function MergersAcquisitionList({ listing, update, deleteee, setModalOpen }) {
  const [selectedId, setSelectedId] = useState(null);

  return (
    <div>
      <div className="row merger-packaged">
        {Array.isArray(listing) && listing?.length > 0 ?
          <>{
            listing?.map((item, index) => (
              <div className="col-md-4" key={index}>
                <div className=" packaged-img">
                  {/* <div className="edu-img">
                  </div> */}
                  <div className="add-button-education">
                    <button onClick={() => setSelectedId(item?.id)}>
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/contestdetails/delete-icon.svg`} />
                    </button>
                    <button onClick={() => { update(item?.id); }}  >
                      <img src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/edit.svg`} />
                    </button>
                  </div>
                  <ProfileImageWithFallback url={item?.logo} style={{ objectFit: 'contain', width: '200px', borderRadius: 0 }} />
                  <h3>{item?.company_name}</h3>
                  <h6>{item?.industry_title}</h6>
                  <h6>{item?.website_link}</h6>
                  <p>{item?.city}-{item?.pincode}</p>
                </div>
                <ConfirmModal
                  isOpen={selectedId === item?.id}
                  toggle={() => setSelectedId(null)}
                  title="Confirm Delete"
                  message="Do you want to delete this item?"
                  onConfirm={() => {
                    deleteee(item?.id);
                    setSelectedId(null);
                  }}
                />
              </div>
            ))
          }
          </>
          : <MANoList setModalOpen={setModalOpen} />
        }
      </div>
    </div>
  );
}
